import React from 'react';
import './styles.scss';
import { Card as CardBox, CardBody, CardTitle } from 'reactstrap';

const Card = ({ title, children }) => {
  return (
    <CardBox className="styled-card-boxs">
      <CardTitle className="styled-card-headers">
        <div className="d-flex pt-3 align-items-center">
          <p className="styled-text-labels">{title}</p>
        </div>
      </CardTitle>
      <CardBody className="styled-card-bodys">{children}</CardBody>
    </CardBox>
  );
};

export default Card;
